
import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { DateCalendar } from "@mui/x-date-pickers";
import dayjs from "dayjs";
const normalizeDays = (day) => (day === 0 ? 7 : day);
const rotateDay = (day) => (day === 0 ? 1 : day === 6 ? 0 : day + 1);

const Schedule = ({
    title,
    availabilityHours = [],
    selectedHour = null,
    onChangeSelectedHour = null,
    expandedButton = true,
    shadowBox = true,
    styles = null,
    fontSize = '1rem'
}) => {
    // availabilityHours can be either an array of arrays or a flat array.
    const hoursContainer = Array.isArray(availabilityHours[0])
        ? availabilityHours[0]
        : (Array.isArray(availabilityHours) ? availabilityHours : []);

    // Helper to extract the string label from an hour entry
    const hourLabel = (hour) => {
        if (!hour) return '';
        if (typeof hour === 'string') return hour;
        return hour.hour || hour.time || '';
    };

    // Determine default value: prefer selectedHour, otherwise availabilityHours[0][0] if exists
    const firstAvailabilityLabel = hourLabel(hoursContainer && hoursContainer.length ? hoursContainer[0] : null);

    const handleChange = (e) => {
        if (typeof onChangeSelectedHour === 'function') onChangeSelectedHour(e.target.value);
    };

    return (
        <Accordion
            defaultExpanded
            sx={{
                mb: '25px',
                borderRadius: '8px',
                boxShadow: shadowBox ? '0px 4px 12px rgba(0, 0, 0, 0.1)' : 'none',
                ...styles
            }}
        >
            {expandedButton && (
                <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls={`${title}-content`}
                    id={`${title}-header`}
                >
                    <Typography sx={{ fontSize }}>{title}</Typography>
                </AccordionSummary>
            )}
            <AccordionDetails sx={{ height: 'auto', padding: shadowBox ? '16px' : '0' }}>
                <FormControl sx={{ '& .MuiFormControlLabel-label': { fontSize } }}>
                    {/* <FormLabel id="schedule">Horario</FormLabel> */}
                    <RadioGroup
                        row
                        aria-labelledby="schedule"
                        name="row-radio-buttons-group"
                        value={selectedHour ? selectedHour : (firstAvailabilityLabel || '')}
                        onChange={handleChange}
                    >
                        {hoursContainer.map((hour) => {
                            const label = hourLabel(hour);
                            if (!label) return null;
                            return (
                                <FormControlLabel
                                    key={label}
                                    control={<Radio />}
                                    label={label}
                                    value={label}
                                />
                            );
                        })}
                        {/* <FormControlLabel value="09:00" control={<Radio />} label="09:00" />
                        <FormControlLabel value="11:00" control={<Radio />} label="11:00" />
                        <FormControlLabel value="14:00" control={<Radio />} label="14:00" /> */}
                    </RadioGroup>
                </FormControl>
            </AccordionDetails>
        </Accordion >
    )
}
export default Schedule;
